import 'svelte/internal/disclose-version';

$.mark_module_start();
App[$.FILENAME] = 'src/svelte/App.svelte';

import * as $ from 'svelte/internal/client';
import { count } from "../store.ts";

var on_change = (_, name) => {
	if ($.get(name).length <= 0) {
		$.set(name, "Jesse");
	}
};

var root = $.add_locations($.template(`<h1 class="text-3xl font-bold underline"> </h1> <input type="text" class="input input-bordered w-full max-w-xs"> <h2 class="text-2xl"> </h2> <button class="btn btn-primary">Increment</button>`, 1), App[$.FILENAME], [
	[7, 0],
	[8, 0],
	[18, 0],
	[19, 0]
]);

function App($$anchor, $$props) {
	$.check_target(new.target);
	$.push($$props, true, App);

	const [$$stores, $$cleanup] = $.setup_stores();

	const $count = () => (
		$.validate_store(count, 'count'),
		$.store_get(count, '$count', $$stores)
	);

	// biome-ignore lint/style/useConst: <explanation>
	let name = $.state("Jesse");
	var fragment = root();
	var h1 = $.first_child(fragment);
	var text = $.child(h1);

	$.reset(h1);

	var input = $.sibling(h1, 2);

	$.remove_input_defaults(input);
	input.__change = [on_change, name];

	var h2 = $.sibling(input, 2);
	var text_1 = $.child(h2);

	$.reset(h2);

	var button = $.sibling(h2, 2);

	button.__click = () => {
		count.value += 1;
		localStorage.setItem("count", count.value.toString());
	};

	$.template_effect(() => {
		$.set_text(text, `Hello, ${$.get(name) ?? ''}`);
		$.set_text(text_1, `Count: ${$count() ?? ''}`);
	});

	$.bind_value(input, () => $.get(name), ($$value) => $.set(name, $$value));
	$.append($$anchor, fragment);

	var $$pop = $.pop({ ...$.legacy_api() });

	$$cleanup();
	return $$pop;
}

if (import.meta.hot) {
	App = $.hmr(App, () => App[$.HMR].source);

	import.meta.hot.accept((module) => {
		module.default[$.HMR].source = App[$.HMR].source;
		$.set(App[$.HMR].source, module.default[$.HMR].original);
	});
}

export default App;

$.mark_module_end(App);
$.delegate(['change', 'click']);